// import { LoadingSpin32 } from '@/components/icons/LoadingSpin';
// import ArticleLoop from '@/components/ui/ArticleLoop';
import { Icon } from '@/components/ui/Icon';
import MetaTag from '@/components/ui/MetaTag';
// import { Pagination } from '@/components/ui/Pagination';
import { PaginationModel } from '@/models/pagination';
// import { useFetchNewsQuery } from '@/pages/api/home';
import React, { useEffect, useState } from 'react';
import { Blog, Post } from './const';
import { Link, LoadingSpin32, Pagination, Image } from '@/components';
import { useFetchNewsQuery } from '../home/api';
import { humanTimeArticle } from '@/libs/dayjs';
import { PagePath } from '@/layouts/shared';
import { MasterDataModel } from '@/models';
import { useMasterData } from '@/contexts/profile';
type BlogLayoutProps = {
  blog: Blog;
};
export const PromotionsLayout = ({ blog }: BlogLayoutProps) => {
  const { id, yoast_head_json } = blog;
  const masterData: MasterDataModel = useMasterData();
  const [articles, setArticles] = useState<Post[]>();
  const [pagination, setPagination] = useState<PaginationModel>({
    page: 1,
    total_page: Math.ceil(blog.count / 5),
  });
  const { refetch: refetchArticle, isLoading } = useFetchNewsQuery(
    { page: pagination?.page || 1, per_page: 5, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setArticles(data.data);
        if (data.pagination) setPagination(data.pagination);
      },
    }
  );
  useEffect(() => {
    refetchArticle();
  }, [refetchArticle, id, pagination]);
  const onPageChange = (page: number) => {
    window.scrollTo(0, 0);
    setPagination((prev) => {
      return {
        ...prev,
        page: page,
      };
    });
  };
  return (
    <>
      <MetaTag title={blog.name} image={`${process.env.APP_URL}/logo-bg.png`} />
      <h1 className="tw-hidden">{yoast_head_json.title}</h1>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        {masterData?.menu_blogs && (
          <div className="tw-overflow-x-scroll md:tw-hidden">
            <div
              className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-overflow-x-scroll tw-w-max`}
            >
              {masterData?.menu_blogs.map((m) => (
                <Link
                  key={m.name}
                  className={`${
                    blog.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                  } !tw-text-secondary-70`}
                  url={{
                    pathname: PagePath.BlogPage,
                    query: {
                      id: m.slug,
                    },
                  }}
                >
                  {m.name}
                </Link>
              ))}
            </div>
          </div>
        )}
        <div>
          <span>Tin tức</span>
          {' > '}
          {blog.name}
        </div>
        {isLoading ? (
          <div className="tw-flex tw-justify-center tw-mt-6">
            <Icon icon={<LoadingSpin32 />} className="tw-w-8 tw-h-8 tw-text-primary-main" />
          </div>
        ) : (
          <>
            <div className="tw-mt-4 lg:tw-mt-6 ">
              {!!articles && (
                <>
                  <div className="tw-pt-6 tw-flex tw-flex-col tw-gap-y-5 md:tw-pt-10">
                    {articles?.map((article: Post) => {
                      return (
                        <div key={'article-' + article.id} className="tw-w-full tw-h-max">
                          <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[420px] 2xl:tw-h-[460px]">
                            <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]">
                              <Image
                                src={article.thumbnail_url || ''}
                                alt={article.title.rendered}
                                className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                                objectFit="cover"
                              />
                              <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center">
                                <div className="tw-text-center">{humanTimeArticle(article.modified, '')}</div>
                                <h3
                                  className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                                  dangerouslySetInnerHTML={{ __html: article.title.rendered }}
                                ></h3>
                                <h4
                                  className="tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic"
                                  dangerouslySetInnerHTML={{ __html: article.yoast_head_json.description || '' }}
                                ></h4>
                                <Link
                                  url={{ pathname: PagePath.ArticlePage, query: { id: article.slug } }}
                                  className="!tw-underline tw-inline-block tw-mt-1"
                                >
                                  Xem thêm {'>'}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {pagination && (
                      <div className="tw-flex tw-mt-5 tw-justify-end">
                        <Pagination
                          page={pagination.page || 0}
                          count={pagination?.total_page || 0}
                          onPageChange={onPageChange}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
export const PromotionsMobileLayout = ({ blog }: BlogLayoutProps) => {
  const { id, yoast_head_json } = blog;
  const masterData: MasterDataModel = useMasterData();
  const [articles, setArticles] = useState<Post[]>();
  const [pagination, setPagination] = useState<PaginationModel>({
    page: 1,
    total_page: Math.ceil(blog.count / 5),
  });
  const { refetch: refetchArticle, isLoading } = useFetchNewsQuery(
    { page: pagination?.page || 1, per_page: 5, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setArticles(data.data);
        if (data.pagination) setPagination(data.pagination);
      },
    }
  );
  useEffect(() => {
    refetchArticle();
  }, [refetchArticle, id, pagination]);
  const onPageChange = (page: number) => {
    window.scrollTo(0, 0);
    setPagination((prev) => {
      return {
        ...prev,
        page: page,
      };
    });
  };
  return (
    <>
      <MetaTag title={blog.name} image={`${process.env.APP_URL}/logo-bg.png`} />
      <h1 className="tw-hidden">{yoast_head_json.title}</h1>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        {masterData?.menu_blogs && (
          <div className="tw-overflow-x-scroll md:tw-hidden">
            <div
              className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5  tw-overflow-x-scroll tw-w-max`}
            >
              {masterData?.menu_blogs.map((m) => (
                <Link
                  key={m.name}
                  className={`${
                    blog.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                  } !tw-text-secondary-70`}
                  url={{
                    pathname: PagePath.BlogMobilePage,
                    query: {
                      id: m.slug,
                    },
                  }}
                >
                  {m.name}
                </Link>
              ))}
            </div>
          </div>
        )}
        <div>
          <span>Tin tức</span>
          {' > '}
          {blog.name}
        </div>
        {isLoading ? (
          <div className="tw-flex tw-justify-center tw-mt-6">
            <Icon icon={<LoadingSpin32 />} className="tw-w-8 tw-h-8 tw-text-primary-main" />
          </div>
        ) : (
          <>
            <div className="tw-mt-4 lg:tw-mt-6 ">
              {!!articles && (
                <>
                  <div className="tw-pt-6 tw-flex tw-flex-col tw-gap-y-5 md:tw-pt-10">
                    {articles?.map((article: Post) => {
                      return (
                        <div key={'article-' + article.id} className="tw-w-full tw-h-max">
                          <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[420px] 2xl:tw-h-[460px]">
                            <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]">
                              <Image
                                src={article.thumbnail_url || ''}
                                alt={article.title.rendered}
                                className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                                objectFit="cover"
                              />
                              <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center">
                                <div className="tw-text-center">{humanTimeArticle(article.modified, '')}</div>
                                <h3
                                  className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                                  dangerouslySetInnerHTML={{ __html: article.title.rendered }}
                                ></h3>
                                <h4
                                  className="tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic"
                                  dangerouslySetInnerHTML={{ __html: article.yoast_head_json.description || '' }}
                                ></h4>
                                <Link
                                  url={{ pathname: PagePath.ArticleMobilePage, query: { id: article.slug } }}
                                  className="!tw-underline tw-inline-block tw-mt-1"
                                >
                                  Xem thêm {'>'}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {pagination && (
                      <div className="tw-flex tw-mt-5 tw-justify-end">
                        <Pagination
                          page={pagination.page || 0}
                          count={pagination?.total_page || 0}
                          onPageChange={onPageChange}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
export const EmagazineLayout = ({ blog }: BlogLayoutProps) => {
  const masterData: MasterDataModel = useMasterData();
  const { id, yoast_head_json } = blog;
  const [articles, setArticles] = useState<Post[]>();
  const [firstArticle, setFirstArticle] = useState<Post>();
  const [pagination, setPagination] = useState<PaginationModel>({
    page: 1,
    total_page: Math.ceil(blog.count / 8),
  });
  const { refetch: refetchArticle, isLoading } = useFetchNewsQuery(
    { offset: ((pagination.page || 1) - 1) * 8 + 1, per_page: 8, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setArticles(data.data);
      },
    }
  );
  const { refetch: refetchNewArticle } = useFetchNewsQuery(
    { page: 1, per_page: 1, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setFirstArticle(data.data[0]);
      },
    }
  );
  useEffect(() => {
    refetchArticle();
  }, [refetchArticle, id, pagination]);
  useEffect(() => {
    refetchNewArticle();
  }, [refetchNewArticle, id]);
  const onPageChange = (page: number) => {
    window.scrollTo(0, 0);
    setPagination((prev) => {
      return {
        ...prev,
        page: page,
      };
    });
  };
  return (
    <>
      <MetaTag title={blog.name} image={`${process.env.APP_URL}/logo-bg.png`} />
      <h1 className="tw-hidden">{yoast_head_json.title}</h1>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        {masterData?.menu_blogs && (
          <div className="tw-overflow-x-scroll md:tw-hidden">
            <div
              className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5  tw-overflow-x-scroll tw-w-max`}
            >
              {masterData?.menu_blogs.map((m) => (
                <Link
                  key={m.name}
                  className={`${
                    blog.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                  } !tw-text-secondary-70`}
                  url={{
                    pathname: PagePath.BlogPage,
                    query: {
                      id: m.slug,
                    },
                  }}
                >
                  {m.name}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div>
          <span>Tin tức</span>
          {' > '}
          {blog.name}
        </div>
      </div>
      <div>
        {isLoading ? (
          <div className="tw-flex tw-justify-center tw-mt-6">
            <Icon icon={<LoadingSpin32 />} className="tw-w-8 tw-h-8 tw-text-primary-main" />
          </div>
        ) : (
          <>
            <div className="tw-mt-4 lg:tw-mt-6 ">
              {firstArticle && pagination.page == 1 && (
                <div key="first-article" className="tw-w-full tw-h-max">
                  <div className="tw-w-full tw-relative tw-h-[460px] xs:tw-h-[640px] md:tw-h-[460px] lg:tw-h-[480px] xl:tw-h-[560px] 2xl:tw-h-[640px] 3xl:tw-h-auto 3xl:tw-mb-[96px]">
                    <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[30%]">
                      <Image
                        src={firstArticle.thumbnail_url || ''}
                        alt={firstArticle.title.rendered}
                        className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                        objectFit="cover"
                      />
                      <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center">
                        <div className="tw-text-center">{humanTimeArticle(firstArticle.modified, '')}</div>
                        <h3
                          className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                          dangerouslySetInnerHTML={{ __html: firstArticle.title.rendered }}
                        ></h3>
                        <h4
                          className="tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic"
                          dangerouslySetInnerHTML={{ __html: firstArticle.yoast_head_json.description || '' }}
                        ></h4>
                        <Link
                          url={{ pathname: PagePath.ArticlePage, query: { id: firstArticle.slug } }}
                          className="!tw-underline tw-inline-block tw-mt-1"
                        >
                          Xem thêm {'>'}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="container tw-pb-10">
              <>
                {!!articles && (
                  <>
                    <div className="tw-mt-6 tw-grid md:tw-grid-cols-2 tw-gap-4 md:tw-gap-6 lg:tw-gap-10 md:tw-mt-10">
                      {articles?.map((article: Post) => {
                        return (
                          <div key={'article-' + article.id} className="tw-w-full tw-h-max">
                            <div className="tw-w-full tw-relative tw-h-[460px] sm:tw-h-[600px] md:tw-h-[400px] lg:tw-h-[520px] 2xl:tw-h-[570px]">
                              <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[72%]">
                                <Image
                                  src={article.thumbnail_url || ''}
                                  alt={article.title.rendered}
                                  className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                                  objectFit="cover"
                                />
                                <div className="tw-w-11/12 md:tw-w-5/6 tw-rounded-t-[28px] tw-p-4 lg:tw-p-6  tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center">
                                  <div className="tw-text-center">{humanTimeArticle(article.modified, '')}</div>
                                  <h3
                                    className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                                    dangerouslySetInnerHTML={{ __html: article.title.rendered }}
                                  ></h3>
                                  <h4
                                    className="tw-mt-2 tw-line-clamp-2 tw-text-sm lg:tw-text-base tw-italic "
                                    dangerouslySetInnerHTML={{ __html: article.yoast_head_json.description || '' }}
                                  ></h4>
                                  <Link
                                    url={{ pathname: PagePath.ArticlePage, query: { id: article.slug } }}
                                    className="!tw-underline tw-inline-block tw-mt-1"
                                  >
                                    Xem thêm {'>'}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
                {pagination && (
                  <div className="tw-flex tw-mt-5 tw-justify-end">
                    <Pagination
                      page={pagination.page || 0}
                      count={pagination?.total_page || 0}
                      onPageChange={onPageChange}
                    />
                  </div>
                )}
              </>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export const EmagazineMobileLayout = ({ blog }: BlogLayoutProps) => {
  const masterData: MasterDataModel = useMasterData();
  const { id, yoast_head_json } = blog;
  const [articles, setArticles] = useState<Post[]>();
  const [firstArticle, setFirstArticle] = useState<Post>();
  const [pagination, setPagination] = useState<PaginationModel>({
    page: 1,
    total_page: Math.ceil(blog.count / 8),
  });
  const { refetch: refetchArticle, isLoading } = useFetchNewsQuery(
    { offset: ((pagination.page || 1) - 1) * 8 + 1, per_page: 8, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setArticles(data.data);
      },
    }
  );
  const { refetch: refetchNewArticle } = useFetchNewsQuery(
    { page: 1, per_page: 1, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setFirstArticle(data.data[0]);
      },
    }
  );
  useEffect(() => {
    refetchArticle();
  }, [refetchArticle, id, pagination]);
  useEffect(() => {
    refetchNewArticle();
  }, [refetchNewArticle, id]);
  const onPageChange = (page: number) => {
    window.scrollTo(0, 0);
    setPagination((prev) => {
      return {
        ...prev,
        page: page,
      };
    });
  };
  return (
    <>
      <MetaTag title={blog.name} image={`${process.env.APP_URL}/logo-bg.png`} />
      <h1 className="tw-hidden">{yoast_head_json.title}</h1>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        {masterData?.menu_blogs && (
          <div className="tw-overflow-x-auto md:tw-hidden">
            <div
              className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-overflow-x-scroll tw-w-max`}
            >
              {masterData?.menu_blogs.map((m) => (
                <Link
                  key={m.name}
                  className={`${
                    blog.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                  } !tw-text-secondary-70`}
                  url={{
                    pathname: PagePath.BlogMobilePage,
                    query: {
                      id: m.slug,
                    },
                  }}
                >
                  {m.name}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div>
          <span>Tin tức</span>
          {' > '}
          {blog.name}
        </div>

        {isLoading ? (
          <div className="tw-flex tw-justify-center tw-mt-6">
            <Icon icon={<LoadingSpin32 />} className="tw-w-8 tw-h-8 tw-text-primary-main" />
          </div>
        ) : (
          <>
            <div className="tw-mt-4 lg:tw-mt-6 ">
              {firstArticle && pagination.page == 1 && (
                <div key="first-article" className="tw-w-full tw-h-max">
                  <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[320px] lg:tw-h-[420px] 2xl:tw-h-[460px]">
                    <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]">
                      <Image
                        src={firstArticle.thumbnail_url || ''}
                        alt={firstArticle.title.rendered}
                        className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                        objectFit="cover"
                      />
                      <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center">
                        <div className="tw-text-center">{humanTimeArticle(firstArticle.modified, '')}</div>
                        <h3
                          className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                          dangerouslySetInnerHTML={{ __html: firstArticle.title.rendered }}
                        ></h3>
                        <h4
                          className="tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic"
                          dangerouslySetInnerHTML={{ __html: firstArticle.yoast_head_json.description || '' }}
                        ></h4>
                        <Link
                          url={{ pathname: PagePath.ArticleMobilePage, query: { id: firstArticle.slug } }}
                          className="!tw-underline tw-inline-block tw-mt-1"
                        >
                          Xem thêm {'>'}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!!articles && (
                <>
                  <div className="tw-mt-6 tw-grid md:tw-grid-cols-2 tw-gap-4 md:tw-gap-6 lg:tw-gap-10 md:tw-mt-10">
                    {articles?.map((article: Post) => {
                      return (
                        <div key={'article-' + article.id} className="tw-w-full tw-h-max">
                          <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[400px] lg:tw-h-[520px] 2xl:tw-h-[570px]">
                            <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[72%]">
                              <Image
                                src={article.thumbnail_url || ''}
                                alt={article.title.rendered}
                                className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                                objectFit="cover"
                              />
                              <div className="tw-w-11/12 md:tw-w-5/6 tw-rounded-t-[28px] tw-p-4 lg:tw-p-6  tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center">
                                <div className="tw-text-center">{humanTimeArticle(article.modified, '')}</div>
                                <h3
                                  className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                                  dangerouslySetInnerHTML={{ __html: article.title.rendered }}
                                ></h3>
                                <h4
                                  className="tw-mt-2 tw-line-clamp-2 tw-text-sm lg:tw-text-base tw-italic "
                                  dangerouslySetInnerHTML={{ __html: article.yoast_head_json.description || '' }}
                                ></h4>
                                <Link
                                  url={{ pathname: PagePath.ArticleMobilePage, query: { id: article.slug } }}
                                  className="!tw-underline tw-inline-block tw-mt-1"
                                >
                                  Xem thêm {'>'}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
            {pagination && (
              <div className="tw-flex tw-mt-5 tw-justify-end">
                <Pagination
                  page={pagination.page || 0}
                  count={pagination?.total_page || 0}
                  onPageChange={onPageChange}
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export const JewelryLayout = ({ blog }: BlogLayoutProps) => {
  const masterData: MasterDataModel = useMasterData();
  const { id, yoast_head_json } = blog;
  const [articles, setArticles] = useState<Post[]>();
  const [firstArticle, setFirstArticle] = useState<Post>();
  const [pagination, setPagination] = useState<PaginationModel>({
    page: 1,
    total_page: Math.ceil(blog.count / 8),
  });
  const { refetch: refetchArticle, isLoading } = useFetchNewsQuery(
    { offset: ((pagination.page || 1) - 1) * 8 + 1, per_page: 9, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setArticles(data.data);
      },
    }
  );
  const { refetch: refetchNewArticle } = useFetchNewsQuery(
    { page: 1, per_page: 1, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setFirstArticle(data.data[0]);
      },
    }
  );
  useEffect(() => {
    refetchArticle();
  }, [refetchArticle, id, pagination]);
  useEffect(() => {
    refetchNewArticle();
  }, [refetchNewArticle, id]);
  const onPageChange = (page: number) => {
    window.scrollTo(0, 0);
    setPagination((prev) => {
      return {
        ...prev,
        page: page,
      };
    });
  };
  return (
    <>
      <MetaTag title={blog.name} image={`${process.env.APP_URL}/logo-bg.png`} />
      <h1 className="tw-hidden">{yoast_head_json.title}</h1>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        {masterData?.menu_blogs && (
          <div className="tw-overflow-x-scroll">
            <div
              className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 md:tw-hidden tw-w-max`}
            >
              {masterData?.menu_blogs.map((m) => (
                <Link
                  key={m.name}
                  className={`${
                    blog.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                  } !tw-text-secondary-70`}
                  url={{
                    pathname: PagePath.BlogPage,
                    query: {
                      id: m.slug,
                    },
                  }}
                >
                  {m.name}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div>
          <span>Tin tức</span>
          {' > '}
          {blog.name}
        </div>
        {isLoading ? (
          <div className="tw-flex tw-justify-center tw-mt-6">
            <Icon icon={<LoadingSpin32 />} className="tw-w-8 tw-h-8 tw-text-primary-main" />
          </div>
        ) : (
          <>
            <div className="tw-mt-4 lg:tw-mt-6 ">
              {firstArticle && pagination.page == 1 && (
                <div key="first-article" className="tw-w-full tw-h-max">
                  <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[360px] lg:tw-h-[420px] 2xl:tw-h-[460px]">
                    <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]">
                      <Image
                        src={firstArticle.thumbnail_url || ''}
                        alt={firstArticle.title.rendered}
                        className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                        objectFit="cover"
                      />
                      <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center">
                        <div className="tw-text-center">{humanTimeArticle(firstArticle.modified, '')}</div>
                        <h3
                          className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                          dangerouslySetInnerHTML={{ __html: firstArticle.title.rendered }}
                        ></h3>
                        <h4
                          className="tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic"
                          dangerouslySetInnerHTML={{ __html: firstArticle.yoast_head_json.description || '' }}
                        ></h4>
                        <Link
                          url={{ pathname: PagePath.ArticlePage, query: { id: firstArticle.slug } }}
                          className="!tw-underline tw-inline-block tw-mt-1"
                        >
                          Xem thêm {'>'}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!!articles && (
                <>
                  <div className="tw-mt-6 tw-grid md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-4 md:tw-gap-5  md:tw-mt-10">
                    {articles?.map((article: Post) => {
                      return (
                        <div key={'article-' + article.id} className="tw-w-full tw-h-max">
                          <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[350px] lg:tw-h-[360px] 2xl:tw-h-[400px]">
                            <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[72%]">
                              <Image
                                src={article.thumbnail_url || ''}
                                alt={article.title.rendered}
                                className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                                objectFit="cover"
                              />
                              <div className="tw-w-11/12 md:tw-w-5/6 tw-rounded-t-[28px] tw-p-4 lg:tw-p-4  tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] tw-text-center">
                                <div className="tw-text-center tw-text-sm">
                                  {humanTimeArticle(article.modified, '')}
                                </div>
                                <Link url={{ pathname: PagePath.ArticlePage, query: { id: article.slug } }}>
                                  <h3
                                    className="tw-mt-2 tw-text-base md:tw-text-lg tw-leading-4 tw-font-semibold tw-text-center tw-line-clamp-2 md:tw-leading-[22px] tw-uppercase tw-text-secondary-70"
                                    dangerouslySetInnerHTML={{ __html: article.title.rendered }}
                                  ></h3>
                                </Link>
                                <h4
                                  className="tw-mt-1 tw-line-clamp-2 tw-text-sm lg:tw-text-base tw-italic "
                                  dangerouslySetInnerHTML={{ __html: article.yoast_head_json.description || '' }}
                                ></h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
            {pagination && (
              <div className="tw-flex tw-mt-5 tw-justify-end">
                <Pagination
                  page={pagination.page || 0}
                  count={pagination?.total_page || 0}
                  onPageChange={onPageChange}
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export const JewelryMobileLayout = ({ blog }: BlogLayoutProps) => {
  const { id, yoast_head_json } = blog;
  const masterData: MasterDataModel = useMasterData();
  const [articles, setArticles] = useState<Post[]>();
  const [pagination, setPagination] = useState<PaginationModel>({
    page: 1,
    total_page: Math.ceil(blog.count / 5),
  });
  const { refetch: refetchArticle, isLoading } = useFetchNewsQuery(
    { page: pagination?.page || 1, per_page: 5, categories: id },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setArticles(data.data);
        if (data.pagination) setPagination(data.pagination);
      },
    }
  );
  useEffect(() => {
    refetchArticle();
  }, [refetchArticle, id, pagination]);
  const onPageChange = (page: number) => {
    window.scrollTo(0, 0);
    setPagination((prev) => {
      return {
        ...prev,
        page: page,
      };
    });
  };
  return (
    <>
      <MetaTag title={blog.name} image={`${process.env.APP_URL}/logo-bg.png`} />
      <h1 className="tw-hidden">{yoast_head_json.title}</h1>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <h2 className="tw-hidden">{yoast_head_json.title}</h2>
      <div className="container tw-pb-10 tw-pt-5 md:tw-pt-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70">
        {masterData?.menu_blogs && (
          <div className="tw-overflow-x-scroll md:tw-hidden">
            <div
              className={`tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-overflow-x-scroll tw-w-max`}
            >
              {masterData?.menu_blogs.map((m) => (
                <Link
                  key={m.name}
                  className={`${
                    blog.slug === m.slug ? 'tw-font-semibold tw-border-b-[3px] tw-border-primary-main' : ''
                  } !tw-text-secondary-70`}
                  url={{
                    pathname: PagePath.BlogMobilePage,
                    query: {
                      id: m.slug,
                    },
                  }}
                >
                  {m.name}
                </Link>
              ))}
            </div>
          </div>
        )}
        <div>
          <span>Tin tức</span>
          {' > '}
          {blog.name}
        </div>
        {isLoading ? (
          <div className="tw-flex tw-justify-center tw-mt-6">
            <Icon icon={<LoadingSpin32 />} className="tw-w-8 tw-h-8 tw-text-primary-main" />
          </div>
        ) : (
          <>
            <div className="tw-mt-4 lg:tw-mt-6 ">
              {!!articles && (
                <>
                  <div className="tw-pt-6 tw-flex tw-flex-col tw-gap-y-5 md:tw-pt-10">
                    {articles?.map((article: Post) => {
                      return (
                        <div key={'article-' + article.id} className="tw-w-full tw-h-max">
                          <div className="tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[420px] 2xl:tw-h-[460px]">
                            <div className="tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]">
                              <Image
                                src={article.thumbnail_url || ''}
                                alt={article.title.rendered}
                                className="!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0"
                                objectFit="cover"
                              />
                              <div className="tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center">
                                <div className="tw-text-center">{humanTimeArticle(article.modified, '')}</div>
                                <h3
                                  className="tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center tw-line-clamp-2"
                                  dangerouslySetInnerHTML={{ __html: article.title.rendered }}
                                ></h3>
                                <h4
                                  className="tw-mt-2 tw-line-clamp-2 tw-text-base tw-italic"
                                  dangerouslySetInnerHTML={{ __html: article.yoast_head_json.description || '' }}
                                ></h4>
                                <Link
                                  url={{ pathname: PagePath.ArticleMobilePage, query: { id: article.slug } }}
                                  className="!tw-underline tw-inline-block tw-mt-1"
                                >
                                  Xem thêm {'>'}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {pagination && (
                      <div className="tw-flex tw-mt-5 tw-justify-end">
                        <Pagination
                          page={pagination.page || 0}
                          count={pagination?.total_page || 0}
                          onPageChange={onPageChange}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
